import type { WorkspaceFeature } from '@/config/workspace-features';
import { selectHasFeature, useAuthStore } from '@/stores/auth';

/** 현재 세션이 이 워크스페이스 기능을 쓸 수 있는가 — 화면 요소 노출 판단용(specs/064). 최종 강제는 서버. */
export function useFeature(feature: WorkspaceFeature): boolean {
  return useAuthStore(selectHasFeature(feature));
}
